module.exports = __webpack_public_path__ + "img/emojiOn.c7fa692.png";